import { SDKResponse } from '@commercetools/frontend-sdk';
import useSWR from 'swr';
import useSdk from 'helpers/hooks/useSdk';
import { ProjectSettings } from './types';

const useProjectSettings = () => {
  const sdk = useSdk();
  const response = useSWR<SDKResponse<ProjectSettings>>('action/project/getProjectSettings', () =>
    sdk.callAction<ProjectSettings>({ actionName: 'project/getProjectSettings' }),
  );

  const data = response.data?.isError ? {} : response.data?.data;

  return { ...response, data };
};

export default useProjectSettings;
